import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import CheckoutButton from "../checkout/CheckoutButton";

const InscriptionModal = ({ show, handleClose, course, newPrice, currency, country }) => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Estado para el loading
  const [paymentAmount, setPaymentAmount] = useState("full"); // Estado para el monto de pago
  const [paymentMethod, setPaymentMethod] = useState(""); // Estado para el método de pago
  const [isCountryLocked, setIsCountryLocked] = useState(false);

  const numericPrice = parseFloat(String(newPrice).replace(/\./g, '').replace(',', '.')) || 0;

  const handleSubmit = async () => {

    setLoading(true); // Activar el estado de carga

    localStorage.setItem("courseData", JSON.stringify({
      student: formData,
      course_name: course.titleMain,
      course_price: newPrice,
      course_currency: currency,
      course_id: course.id,
      send_inscription: true
    }));

    try {
      // Crear un objeto FormData
      formData.course_name = course.titleMain;
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const apiUrl = `${process.env.REACT_APP_HOST_BACKEND}/send_inscription`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formDataToSend,
        mode: 'cors'
      });

      const result = await response.json();

      if (result.status === "success") {
        handleClose(); // Cerrar el modal después de enviar
        navigate('/success'); // Redirigir a la página de éxito
      } else {
        handleClose(); // Cerrar el modal después de enviar
        navigate('/rejected'); // Redirigir a la página de rechazo
      }
    } catch (error) {
      alert("Hubo un problema al enviar la inscripción.");
    } finally {
      setLoading(false); // Desactivar el estado de carga
    }
  };

  const [formData, setFormData] = useState({
    fullName: "",
  //  identificationDocument: "",
    email: "",
  //  age: "",
  //  gender: "",
    phone: "",
   // experience: "",
  //  universityStudent: "",
    country: "",
    paymentProof: null,
    nameHolder: "",
    emailHolder: "",
  });

  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showPaymentProof, setShowPaymentProof] = useState(false);
  const [showPaymentInfo, setShowPaymentInfo] = useState("");

  useEffect(() => {
    if (country) {
      const knownCountries = ["VE", "CO", "CL", "PE", "US", "MX", "ES", "AR"];
      const isKnown = knownCountries.includes(country.toUpperCase());
      
      // Si el país es conocido, se selecciona y se bloquea. Si no, se selecciona "otro" y se deja abierto.
      const selectedCountry = isKnown ? country.toUpperCase() : "other";
      setIsCountryLocked(isKnown);

      // Se actualiza el formulario y las opciones de pago con el país seleccionado.
      setFormData((prev) => ({ ...prev, country: selectedCountry }));
      updatePaymentOptions(selectedCountry);
    }
  }, [country, show]); // Se ejecuta cuando se abre el modal o cambia el país.

    // Función para centralizar la lógica de opciones de pago.
  const updatePaymentOptions = (selectedCountry) => {
      setShowPaymentProof(selectedCountry === "CO" || selectedCountry === "VE");
      if (selectedCountry === "VE") {
        setShowPaymentInfo("ve");
      } else if (selectedCountry === "CO") {
        setShowPaymentInfo("co");
      } else {
        setShowPaymentInfo(selectedCountry);
      }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
    // Si eligen pasarela, nos aseguramos de que no se muestre el campo para subir archivo
    if (method === 'gateway') {
      setShowPaymentProof(false);
    } else {
      setShowPaymentProof(true);
    }
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      paymentProof: e.target.files[0],
    }));
  };

  const handleCountryChange = (e) => {
    const country = e.target.value;
    setFormData((prev) => {
      const newState = { ...prev, country };
      return newState;
    });

    // Mostrar botón de pago si no es CO o VE
    setShowPaymentDetails(country !== "" && country !== "VE");

    // Mostrar campo de comprobante solo si es CO o VE
    setShowPaymentProof(country === "CO" || country === "VE");

    // Mostrar datos de pago solo si es CO o VE
    if (country === "VE") {
      setShowPaymentInfo("ve");
    } else if (country === "CO") {
      setShowPaymentInfo("co");
    } else {
      setShowPaymentInfo(country);
    }
  };
  
  // Condición para saber si se debe mostrar la pasarela de pago
  const isCardPayment = (showPaymentInfo !== "ve" && showPaymentInfo !== "co" && showPaymentInfo !== "") || (showPaymentInfo === "co" && paymentMethod === "gateway");

  // Verificar si todos los campos están completos
  const isFormComplete =
    formData.fullName &&
  //  formData.identificationDocument &&
    formData.email &&
  //  formData.age &&
  //  formData.gender &&
    formData.phone &&
 //   formData.experience &&
 //   formData.universityStudent &&
    formData.country &&
    (!showPaymentProof || formData.paymentProof) && // Si se requiere el comprobante, debe estar adjunto.
    (!isCardPayment && (showPaymentProof) || (
      formData.nameHolder &&
      formData.emailHolder
  ));

  // Calcular el monto a pagar según la selección
  const calculatedPrice = paymentAmount === "full" ? numericPrice : Math.round(numericPrice * 0.6);
  
  const totalCost = `${calculatedPrice.toLocaleString("de-DE")} ${currency}`;

  const items = [
    {
      id: course?.id,
      title: course?.titleMain || "Curso Online",
      price: calculatedPrice,
      quantity: 1,
      currency: currency === "$" ? "USD" : currency,
      country: country,
    },
  ];

  return (
    <Modal show={show} onHide={handleClose} centered className="custom-modal">
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title>Formulario de Inscripción</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="loading-spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Form encType="multipart/form-data">
          <Form.Group className="mb-3">
            <Form.Label>Nombre del Estudiante</Form.Label>
            <Form.Control type="text" name="fullName" onChange={handleInputChange} required />
          </Form.Group>

        {/*  <Form.Group className="mb-3">
            <Form.Label>Número de Identificación</Form.Label>
            <Form.Control type="text" name="identificationDocument" onChange={handleInputChange} required />
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>Correo Electrónico</Form.Label>
            <Form.Control type="email" name="email" onChange={handleInputChange} required />
          </Form.Group>
{/*
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Edad</Form.Label>
                <Form.Control type="number" name="age" onChange={handleInputChange} required />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Sexo</Form.Label>
                <Form.Select className="form-control" name="gender" onChange={handleInputChange} required>
                  <option value="">Selecciona</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Femenino">Femenino</option>
                  <option value="Otro">Otro</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
*/}
          <Form.Group className="mb-3">
            <Form.Label>Número de Celular</Form.Label>
            <Form.Control type="tel" name="phone" onChange={handleInputChange} required />
          </Form.Group>
{/*
          <Form.Group className="mb-3">
            <Form.Label>¿A qué te dedicas?</Form.Label>
            <div className="d-flex justify-content-center gap-3">
              <Form.Check type="radio" label="Emprendedor" name="experience" value="Emprendedor" onChange={handleInputChange} required />
              <Form.Check type="radio" label="Empleado" name="experience" value="Empleado" onChange={handleInputChange} />
              <Form.Check type="radio" label="Ninguna" name="experience" value="Ninguna" onChange={handleInputChange} />
            </div>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>¿Eres estudiante universitario?</Form.Label>
            <div className="d-flex justify-content-center gap-3">
              <Form.Check type="radio" label="Sí" name="universityStudent" value="Si" onChange={handleInputChange} required />
              <Form.Check type="radio" label="No" name="universityStudent" value="No" onChange={handleInputChange} />
            </div>
          </Form.Group>
*/}
          {/* --- CAMPO DE PAÍS MODIFICADO --- */}
          <Form.Group className="mb-3">
            <Form.Label>País de Inscripción</Form.Label>
            <Form.Select 
              className="form-control" 
              name="country" 
              value={formData.country} 
              disabled={isCountryLocked} 
              onChange={handleCountryChange}
              required
            >
              <option value="">Selecciona un país</option>
              <option value="VE">Venezuela</option>
              <option value="CO">Colombia</option>
              <option value="CL">Chile</option>
              <option value="PE">Peru</option>
              <option value="US">Estados Unidos</option>
              <option value="MX">México</option>
              <option value="ES">España</option>
              <option value="AR">Argentina</option>
              <option value="other">Otro</option>
            </Form.Select>
          </Form.Group>

          {/* Selección del monto a pagar */}
          <Form.Group className="mb-3">
            <Form.Label>Selecciona el monto a pagar</Form.Label>
            <div className="d-flex gap-3">
              <Button
                variant={paymentAmount === "half" ? "primary" : "outline-primary"}
                onClick={() => setPaymentAmount("half")}
              >
                Pagar sólo inscripción ({Math.round(numericPrice * 0.6).toLocaleString("de-DE")} {currency} )
              </Button>
              <Button
                variant={paymentAmount === "full" ? "primary" : "outline-primary"}
                onClick={() => setPaymentAmount("full")}
              >
                Pagar curso completo ({newPrice} {currency})
              </Button>
            </div>
          </Form.Group>

          {showPaymentInfo === "co" && (
            <Alert variant="info">
              <strong>Elige tu método de pago:</strong>
              <div className="d-flex gap-3 mt-2">
                <Button
                  variant={paymentMethod === "bank" ? "primary" : "outline-primary"}
                  onClick={() => handlePaymentMethodChange("bank")}
                >
                  Pago por transferencia
                </Button>
                <Button
                  variant={paymentMethod === "gateway" ? "primary" : "outline-primary"}
                  onClick={() => handlePaymentMethodChange("gateway")}
                >
                  Pago con pasarela
                </Button>
              </div>
            </Alert>
          )}

          {/* Datos de pago para Venezuela */}
          {showPaymentInfo === "ve" && (
            <Alert variant="info">
              <strong>Pago Móvil</strong>
              <br />
              <strong>Banco:</strong> Provincial <br />
              <strong>Cédula:</strong> 19241582 <br />
              <strong>Celular:</strong> 0416-3574963
              <Form.Group className="mt-2">
                <Form.Label>Comprobante de Pago</Form.Label>
                <Form.Control type="file" accept="image/*" name="paymentProof" onChange={handleFileChange} required />
                <Form.Text className="text-muted">
                  Adjunta una imagen del comprobante en formato JPG o PNG.
                </Form.Text>
              </Form.Group>
            </Alert>
          )}

          {/* Datos de pago para Colombia */}
          {(showPaymentInfo === "co" && paymentMethod === "bank") && (
            <Alert variant="info">
              <strong>Datos de Pago:</strong> <br />
              <strong>Bancolombia - Cuenta de Ahorros:</strong> 00689258018 <br />
              <strong>Nequi:</strong> 3177169274 <br />
              <Form.Group className="mt-2">
                <Form.Label>Comprobante de Pago</Form.Label>
                <Form.Control type="file" accept="image/*" name="paymentProof" onChange={handleFileChange} required />
                <Form.Text className="text-muted">
                  Adjunta una imagen del comprobante en formato JPG o PNG.
                </Form.Text>
              </Form.Group>
            </Alert>
          )}

          {((showPaymentInfo !== "ve" && showPaymentInfo !== "co" && showPaymentInfo !== "") || (showPaymentInfo === "co" && paymentMethod === "gateway")) && (
            <>
            <Form.Group className="mb-3">
              <Form.Label>Nombre del pagador</Form.Label>
              <Form.Control type="text" placeholder="Tal como aparece en su tarjeta" name="nameHolder" onChange={handleInputChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Correo del pagador</Form.Label>
              <Form.Control type="text" name="emailHolder" onChange={handleInputChange} required />
            </Form.Group>
            </>
          )}

          <div class="payment-box">
            <div class="payment-header">
              <span>Total a Pagar</span>
            </div>
            <div class="payment-amount">
              <span id="totalAmount">{totalCost}</span>
            </div>
            <h6 style={{color: 'white'}}>Pago 100% Seguro</h6>
          </div>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose} disabled={loading}>Cerrar</Button>
            {/* Si es pago con pasarela, muestra CheckoutButton. Si no, muestra el botón de compra manual. */}
            {isCardPayment ? (
              <CheckoutButton items={items} formData={formData} disabled={!isFormComplete} type={1} /* El tipo 1 es para Cursos*/ />
            ) : (
              <Button variant="primary" disabled={!isFormComplete || loading} onClick={handleSubmit}>
                {loading ? "Enviando..." : "Enviar Inscripción"}
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default InscriptionModal;
